
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blogId]",
      function () {
        return require("private-next-pages/blog/[blogId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[blogId]"])
      });
    }
  